import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=11822878&scoped=true&"
import script from "./Spinner.vue?vue&type=script&lang=js&"
export * from "./Spinner.vue?vue&type=script&lang=js&"
import style0 from "./Spinner.vue?vue&type=style&index=0&id=11822878&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11822878",
  null
  
)

export default component.exports